import { Cookiebar, Modal } from 'bootstrap-italia';
import './cookie-preferences.scss';

const CONSENT_COOKIE = 'cookies_consent';

// Consenso ai contenuti di terze parti incorporati (video, podcast, post social): cookie separato da
// cookies_consent, che resta letto da Bootstrap Italia (banner) e da matomo.ftl. Opt-in: se manca o
// vale false il consenso non c'è
const THIRD_PARTY_COOKIE = 'cookies_consent_third_party';

// Durata delle scelte: 12 mesi, sia dal banner sia dalle preferenze
const CONSENT_DAYS = 365;

// Evento emesso su document quando l'utente concede un consenso senza ricaricare la pagina:
// detail = { analytics, thirdParty }
export const CONSENT_CHANGE_EVENT = 'a70:cookie-consent-change';

// Ancora che apre la modale: un link che termina con #preferenze-cookie, inserito dalla
// redazione nel testo di una pagina (es. Privacy Policy), apre le preferenze invece di navigare
const PREFERENCES_HASH = '#preferenze-cookie';

/**
 * Legge il valore di un cookie, undefined se assente
 */
function readCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? match[1] : undefined;
}

/**
 * Imposta un cookie con durata in giorni
 */
function writeCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

/**
 * version    1.0
 * class      <type> (CookiePreferences)
 * classdesc  Modale di gestione delle preferenze dei cookie
 */
export class CookiePreferences {
  constructor() {
    this.init();
  }

  // private methods

  init() {
    const self = this;
    const modal = document.getElementById('modalcookie');

    /**
     * Salva preferenze cookie selettive
     */
    $('#s-pref').on('click', () => {
      const analyticsEnabled = $('#analitycs-cookie').is(':checked');
      const thirdPartyEnabled = $('#third-party-cookie').is(':checked');
      const thirdPartyRevoked = !thirdPartyEnabled && CookiePreferences.hasThirdPartyConsent();
      self.setCookie(CONSENT_COOKIE, analyticsEnabled, CONSENT_DAYS);
      self.setCookie(THIRD_PARTY_COOKIE, thirdPartyEnabled, CONSENT_DAYS);

      if (!analyticsEnabled) {
        self.removeMatomoCookies();
      }

      // Revoca: si ricarica la pagina, così tracker ed embed già caricati spariscono
      if (!analyticsEnabled || thirdPartyRevoked) {
        window.location.reload();
        return;
      }

      self.notifyConsentChange();
    });

    /**
     * Accetta tutti i cookie
     */
    $('#s-all').on('click', () => {
      self.acceptAll();
    });

    /**
     * "Accetto tutti" dal banner: Bootstrap Italia scrive solo cookies_consent=true per 30 giorni.
     * Dopo il suo gestore (stesso clic) si riscrive il consenso a 12 mesi e si aggiunge quello
     * alle terze parti
     */
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-bs-accept="cookiebar"]')) {
        setTimeout(() => self.acceptAll(), 0);
      }
    });

    /**
     * "X" del banner: continua senza accettare, con le impostazioni di default. Niente terze parti;
     * gli analitici WAI, assimilati ai tecnici (IP anonimizzato), restano attivi come opt-out
     */
    $('.cookiebar-close').on('click', (event) => {
      self.setCookie(CONSENT_COOKIE, true, CONSENT_DAYS);
      self.setCookie(THIRD_PARTY_COOKIE, false, CONSENT_DAYS);
      Cookiebar.getOrCreateInstance(event.currentTarget.closest('.cookiebar')).hide();
    });

    self.trackCookiebarHeight();

    if (!modal) {
      return;
    }

    /**
     * Apertura preferenze cookie, dal banner o da un link nel testo: l'interruttore
     * mostra la scelta già salvata e il banner si nasconde finché la modale è aperta
     */
    modal.addEventListener('show.bs.modal', () => {
      $('#analitycs-cookie').prop('checked', self.getCookie(CONSENT_COOKIE) !== 'false');
      $('#third-party-cookie').prop('checked', CookiePreferences.hasThirdPartyConsent());
      $('.cookiebar').hide();
    });

    /**
     * Chiusura modale senza aver espresso una scelta (X, Esc o clic fuori):
     * il banner torna visibile
     */
    modal.addEventListener('hidden.bs.modal', () => {
      if (self.getCookie(CONSENT_COOKIE) === undefined) {
        $('.cookiebar').show();
      }
    });

    /**
     * Link alle preferenze nel testo delle pagine: la redazione inserisce dall'editor un link di
     * tipo URL con indirizzo "#preferenze-cookie". Conta solo l'ancora, quindi funziona anche un
     * indirizzo completo che termina con #preferenze-cookie
     */
    document.querySelectorAll('a[href*="#"]').forEach((link) => {
      if (link.hash === PREFERENCES_HASH) {
        link.setAttribute('aria-haspopup', 'dialog');
      }
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (link && link.hash === PREFERENCES_HASH) {
        event.preventDefault();
        Modal.getOrCreateInstance(modal).show();
      }
    });

    /**
     * Pagina aperta con l'ancora nell'indirizzo (link da un'altra pagina): la modale si apre
     * dopo il load, quando il banner ha già deciso se mostrarsi, così show.bs.modal lo nasconde
     */
    if (window.location.hash === PREFERENCES_HASH) {
      const open = () => Modal.getOrCreateInstance(modal).show();
      if (document.readyState === 'complete') {
        open();
      } else {
        window.addEventListener('load', open);
      }
    }
  }

  /**
   * Altezza del banner fisso in --cookiebar-height (0 quando è nascosto), usata da scroll-padding-bottom
   * perché un elemento che riceve il focus non resti coperto dal banner
   */
  trackCookiebarHeight() {
    const bar = document.querySelector('.cookiebar');
    if (!bar || !('ResizeObserver' in window)) {
      return;
    }
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--cookiebar-height', `${bar.offsetHeight}px`);
    }).observe(bar);
  }

  /**
   * true se l'utente ha acconsentito ai contenuti di terze parti (default: no)
   */
  static hasThirdPartyConsent() {
    return readCookie(THIRD_PARTY_COOKIE) === 'true';
  }

  /**
   * Salva la scelta sui contenuti di terze parti (es. dal segnaposto di un embed bloccato)
   */
  static setThirdPartyConsent(enabled) {
    writeCookie(THIRD_PARTY_COOKIE, enabled, CONSENT_DAYS);
  }

  /**
   * Consenso a tutte le categorie
   */
  acceptAll() {
    this.setCookie(CONSENT_COOKIE, true, CONSENT_DAYS);
    this.setCookie(THIRD_PARTY_COOKIE, true, CONSENT_DAYS);
    this.notifyConsentChange();
  }

  /**
   * Avvisa gli altri componenti (es. gli embed in attesa di consenso) delle scelte correnti
   */
  notifyConsentChange() {
    document.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, {
      detail: {
        analytics: this.getCookie(CONSENT_COOKIE) !== 'false',
        thirdParty: CookiePreferences.hasThirdPartyConsent(),
      },
    }));
  }

  /**
   * Legge il valore di un cookie, undefined se assente
   */
  getCookie(name) {
    return readCookie(name);
  }

  /**
   * Imposta un cookie con durata in giorni
   */
  setCookie(name, value, days) {
    writeCookie(name, value, days);
  }

  /**
   * Cancella i cookie di Matomo (_pk_id, _pk_ses, ...) lasciati dalle visite precedenti
   */
  removeMatomoCookies() {
    document.cookie.split(';')
      .map((cookie) => cookie.split('=')[0].trim())
      .filter((name) => name.indexOf('_pk_') === 0)
      .forEach((name) => {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      });
  }
}
